import React from 'react';
import { Link } from 'react-router-dom';

import s from './styles.module.scss';

import type { IDropdownLinks } from '../../types';

interface IProps {
  data: IDropdownLinks;
  onClick: () => void;
}

const HeaderSmallLinks: React.FC<IProps> = (props) => {
  const { data, onClick } = props;
  return (
    <ul className={s.dropdown}>
      {data.links.map((linkGroup) =>
        linkGroup.map((link) => (
          <div key={link.link} onClick={onClick}>
            <Link data-cy={link.dataCy} to={link.link} target={link.target}>
              <li className={s.item}>{link.label}</li>
            </Link>
          </div>
        )),
      )}
    </ul>
  );
};

export default HeaderSmallLinks;
